<div>
  <!-- Menu close icon -->
  <!-- <div class="menuActionContainer">
    <div class="menuIcon" (click)="close()"  pTooltip="Close Message Menu"
    tooltipPosition="top"
    tooltipStyleClass="leftTooltip ui-tooltip-text">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M7.00015 6.79999L17 16.7998M7 17.0135L16.9998 7.01362"
          stroke="#272727"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="menuName">Messages</div>
  </div> -->
  <div class="menucontainer">
    <div class="menuHeading">
      <div class="menuText">Messages</div>
      <div style="display: flex; align-items: center;">
        <button (mouseover)="isPinHovered = true" (mouseout)="isPinHovered = false" (focus)="isPinHovered = true"
          (blur)="isPinHovered = false" style="display: flex; align-items: center;margin-right: 10px;"
          (click)="onPinPanel()" (keydown)="onPinPanelKeyDown($event)" tabindex="0">
          <!-- When not pinned -->
          <img *ngIf="!isMessageMenuPinned && !isPinHovered" src="assets/Inbox/pin.svg" alt="Pin Message Menu" />
          <img *ngIf="!isMessageMenuPinned && isPinHovered" src="assets/Inbox/pinHighlight.svg" alt="Pin Message Menu" />
          <!-- When pinned -->
          <img *ngIf="isMessageMenuPinned && !isPinHovered" src="assets/Inbox/sideBarPin.svg" alt="Unpin Message Menu" />
          <img *ngIf="isMessageMenuPinned && isPinHovered" src="assets/Inbox/sideBarPinHover.svg"
            alt="Unpin Message Menu" />
        </button>
        <button *ngIf="!activeMenuArray[3]" (click)="onMenuClick(3, true)" (keydown)="onMenuIconKeyDown($event)"
          tabindex="0" aria-label="Expand Messages Menu"
          style="background: none; border: none; padding: 0; display: flex; align-items: center;">
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
            <path d="M1.75 1L6.25 6L1.75 11" stroke="#000F29" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <button *ngIf="activeMenuArray[3]" (click)="onMenuClick(3, true)" (keydown)="onMenuIconKeyDown($event)" tabindex="0"
          aria-label="Collapse Messages Menu"
          style="background: none; border: none; padding: 0; display: flex; align-items: center;">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
            <path d="M1 6.25L6 1.75L11 6.25" stroke="#000F29" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
    <!-- for message submenu -->
    <div *ngIf="activeMenuArray[3]" class="childWrapper">
      <div *ngFor="let item of msgItems">
        <div
          [ngClass]="{'active-menu': activeTab?.header === item.name, 'menuChild': activeTab?.header !== item.name}"
        >
          <div class="textlink">
            <div
              class="menuChildText"
              [ngClass]="{'childParent': item.childList && item.count>0}"
              (click)=" onClickMenuItem(item.label, item.count,null,null,false)"
              [pTooltip]="item.childList && item.count>0 ? item.name : null"
              tooltipPosition="top"
              tooltipStyleClass="leftTooltip ui-tooltip-text"
            >
              {{item.name}}
            </div>
            <img  alt="Open"
            src="assets/Inbox/openInNewTab.svg"  class="hoverIcon" pTooltip="Open in a New Tab"
            tooltipPosition="top"
            tooltipStyleClass="leftTooltip ui-tooltip-text" (click)=" onClickMenuItem(item.label, item.count,null,null,true)">
          </div>

          <div class="add-flex">
            <div *ngIf="item.count>0" class="menuChildCount">{{item.count}}</div>
            <div *ngIf="item.childList" (click)="onTagsClick(0)">
              <svg
                *ngIf="!activeTagsMenu[0]"
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
              >
                <path
                  d="M1.75 1L6.25 6L1.75 11"
                  stroke="#000F29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <svg
                *ngIf="activeTagsMenu[0]"
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="8"
                viewBox="0 0 12 8"
                fill="none"
              >
                <path
                  d="M1 6.25L6 1.75L11 6.25"
                  stroke="#000F29"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

        </div>
        <!-- for pottential escalations submenu -->
        <div *ngIf="item.childList" [hidden]="!activeTagsMenu[0]">
          <div
            *ngFor="let listItem of item.childList"
            class="menuChild"
            [ngClass]="{'active-menu': activeTab?.header === 'Esc: '+listItem.name, 'menuChild': activeTab?.header !== 'Esc: '+listItem.name}"
          >
            <div class="thirdChildWrapper">
              <div
                class="menuChildText"
                (click)="onClickMenuItemSubMenu(listItem.label, listItem.count, listItem.name,false)"
              >
                {{listItem.name}}
              </div>
              <img  alt="Open"
            src="assets/Inbox/openInNewTab.svg"  class="hoverIcon" pTooltip="Open in a New Tab"
            tooltipPosition="top"
            tooltipStyleClass="leftTooltip ui-tooltip-text" (click)="onClickMenuItemSubMenu(listItem.label, listItem.count, listItem.name,true)">
            </div>
            <div *ngIf="listItem.count > 0" class="menuChildCount">
              {{listItem.count}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Search for views and group tags -->
    <div class="search-container">
      <input
        type="text"
        placeholder="Search Views And Tags"
        class="search-input"
        #myInput
        (input)="filterItem(myInput.value)"
      />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M8.14295 8.14297L11 11M5.09089 1C4.28179 1 3.49086 1.23993 2.81811 1.68944C2.14537 2.13895 1.62103 2.77786 1.3114 3.52537C1.00177 4.27289 0.920759 5.09543 1.07861 5.88898C1.23645 6.68254 1.62607 7.41146 2.1982 7.98358C2.77032 8.5557 3.49924 8.94532 4.2928 9.10317C5.08635 9.26102 5.90889 9.18001 6.65641 8.87038C7.40392 8.56075 8.04283 8.03641 8.49234 7.36367C8.94185 6.69092 9.18178 5.89999 9.18178 5.09089C9.18171 4.00594 8.75068 2.96545 7.98351 2.19827C7.21633 1.43109 6.17584 1.00007 5.09089 1Z"
          stroke="#7E819B"
          stroke-width="1.4"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </svg>
    </div>

    <!-- for views -->
    <app-search-list
      [name]="'myViews'"
      [placeholder]="viewSearchPlaceholder"
      [items]="filteredItems"
      [listStyle]="{'height':'180px','text-decoration':'underline'}"
      (onItemSelect)="onMyViewsItem($event)"
      (onMenuClick)="onMenuClick(4, true)"
      (openMyViewsPopUp)="openMyViewsPopUp(undefined)"
      [activeTab]="activeTab"
    >
    </app-search-list>

    <div class="divider"></div>

    <!-- for group tags -->
    <app-collapsible-list
      [placeholder]="tagsSearchPlaceholder"
      [items]="filteredItemsGroupTags"
      (onItemSelect)="OnGroupTagSelect($event)"
      (onTagsClick)="onTagsClick(1)"
      [active]="activeTagsMenu[1]"
      [activeTab]="activeTab"
    >
    </app-collapsible-list>
  </div>
</div>

<!-- different modal popups -->
<p-dialog
  [(visible)]="myViewBoolean"
  modal="true"
  class="myView"
  [styleClass]="'viewModal'"
  [style]="{'top':'120px !important','border':'1px solid #002d72','background':'#fff'}"
  appendTo="body"
  showHeader="true"
  [resizable]="false"
  closable="false"
>
  <p-header>
    <div
      class="d-flex flex-row align-items-center justify-content-between"
      style="margin-left: 15px"
    >
      <div class="header" style="width: 100%;">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div>
            <span style="font-size: 16px;color:#FFFFFF;font-family:OpenSansSemiBold;line-height: 21.79px;font-weight: 600;">
              {{ isCreateView ? 'Create New View' : 'My View Criteria' }}
            </span>
          </div>
        <div>
          <button type="button" (click)="hideMyViewModal()" class="d-flex flex-row close qma-text"
            style="margin: 0px 6px 0px 0px;">
            <img src="assets/qwyn/icons/close-grey.svg" alt="Close">
          </button>
        </div>
        </div>
      </div>
    </div>
  </p-header>
  <app-myviews [myViewsItems]="myViewsItems" [fromSideNav]="true"></app-myviews>
</p-dialog>
<!-- Responsive Design-->
<p-dialog
  [(visible)]="myReportBoolean"
  [styleClass]="'reportModal'"
  modal="true"
  class="myView"
  [style]="{'top':'120px !important','border':'1px solid #002d72','background':'#fff'}"
  appendTo="body"
  showHeader="false"
  closeIcon=""
  [resizable]="false"
>
  <p-header>
    <div
      class="d-flex flex-row align-items-center justify-content-between"
      style="margin-left:27px"
    >
      <h6 class="gfid-title" style="font-size: 20px">REQUEST MIS REPORT</h6>

      <button
        type="button"
        (click)="hideReportModal($event)"
        class="d-flex flex-row close qma-text"
        style="border:none !important;opacity:1;outline: none;"
      >
        <img
          src="assets/Inbox/close_icon_u73.svg"
          style="opacity:1"
          alt="Close"
        />
        <h6>CLOSE</h6>
      </button>
    </div>
  </p-header>
</p-dialog>
<app-action-popup></app-action-popup>

<!-- symphony changes -->
<p-dialog
  [(visible)]="isServiceSymponyError"
  [styleClass]="'symphony-service-error'"
  header=" Symphony services unavailable please try again later"
  [style]="{'font-size': '12px !important','font-family':'InterstateLight !important','color': '#002d72 !important','text-transform': 'none !important'}"
>
</p-dialog>
